import '../css/HomeDescription.css'; // Import your updated CSS file
import image from '../images/descriptionImg.jpg'; // Replace with your actual image path
import LandSearch from './HomeSearchLand';
const HomeDescription = () => {
    return (
        <>
            <section className="description">
                <div className="description-text">
                    <h1 className="home-title">Welcome to <span className="highlight">KhetBazaar</span></h1>
                    <p className="home-text">
                        At <strong>KhetBazaar</strong>, we simplify buying, selling, and leasing of farming lands and houses. With verified listings, a user-friendly platform, and expert support, we connect buyers, sellers, and renters seamlessly.
                    </p>
                    <ul className="features-list">
                        <li><strong>Wide Listings:</strong> Find fertile farmlands, serene homes, and lucrative investment opportunities.</li>
                        <li><strong>Transparency:</strong> Verified properties for secure and hassle-free transactions.</li>
                        <li><strong>Expert Support:</strong> Get guidance every step of the way.</li>
                    </ul>
                    <p className="cta">
                        Join thousands who trust <strong>KhetBazaar</strong> for their real estate needs. <span className="highlight">Start your journey today</span> and turn your dreams into reality!
                    </p>
                </div>
                <div className="description-image">
                    <img src={image} alt="KhetBazaar" />
                </div>
            </section>
            <div className='search-land'>
            {/* <h2>Search your dream Land</h2> */}
            </div>
            <div >
                <LandSearch/>
            </div>

        </>

    );
};

export default HomeDescription;
